import { ErrorBase } from './ErrorBase';
import { Error } from 'fl-foundation';

export class QPError extends ErrorBase {
  error: Error;
  errorType: any;

  constructor(message: any | undefined, error: Error, errorType?: any) {
    super(message);
    this.error = error;
    this.errorType = errorType;
  }
}
